import React from 'react'
import HomePage from '../component/HomePage'

const HomeContainer = () => {
  return (
    <HomePage/>
  )
}

export default HomeContainer